import React,  {useState} from "react";
import { Link   } from "react-router-dom";

import ForumShowOnCompany from 'pages/forum/ForumShowOnCompany'


export default function Forumsection({companyinfo}) {
   
  return (
      <section className="bg-white shadow-md z-50 rounded-xl p-5">
        <div></div>
            <ForumShowOnCompany product={companyinfo} />     
      </section> 
  );
}
